export default __webpack_public_path__ + "static/media/bt3.8cba2578.jpg";